import React, { useContext, useState, useEffect } from 'react'
import EmployeeForm from '@/product/components/species/employee/EmployeeForm'
import { handleRedirectInternal } from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import Layout from '@/product/components/templates/Layout'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'

const EmployeeEdit = (props) => {
    const commonContext = useContext(CommonContext)
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const { USStates, allCountries, allStates } = commonContext
    let employeeId = props.match?.params?.eid ? props.match.params.eid : 0

    const [initialValues, setInitialValues] = useState({
        id: 0,
        emp_email: '',
        confirm_email: '',
        emp_firstname: '',
        emp_lastname: '',
        emp_address1: '',
        emp_phone: '',
        emp_type: 'employee',
        emp_city: '',
        emp_state: '',
        change_password: true,
        emp_country: 'US',
        emp_zip: '',
        emp_permissions: [],
    })
    const [passwordInitialValues, setPasswordInitialValues] = useState({
        id: 0,
        change_password: true,
        password: '',
        confirm_password: '',
    })
    const resetFrom = () => {
        setInitialValues({
            id: 0,
            emp_email: '',
            confirm_email: '',
            emp_firstname: '',
            emp_lastname: '',
            emp_address1: '',
            emp_phone: '',
            emp_type: 'employee',
            emp_city: '',
            emp_state: '',
            emp_country: 'US',
            emp_zip: '',
            emp_permissions: [],
        })
        setPasswordInitialValues({
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        })
        // formik.handleReset()
        // formikPassword.handleReset()
        // setIsLoading(false)
    }
    const employeeFunctionEdit = (single_employee) => {
        if (
            single_employee.record &&
            Object.keys(single_employee.record).length
        ) {
            const user = single_employee.record
            setInitialValues({
                id: user.id,
                emp_email: user.emp_email,
                emp_firstname: user.emp_firstname,
                emp_lastname: user.emp_lastname,
                emp_address1: user.emp_address1,
                emp_phone: user.emp_phone,
                emp_type: user.emp_type ? user.emp_type : 'employee',
                emp_city: user.emp_city,
                emp_state: user.emp_state,
                emp_country: user.emp_country,
                emp_zip: user.emp_zip,
                emp_permissions: user.emp_permissions.split(','),
            })
            //setReload(!reload)
        } else {
            resetFrom()
        }
        //setIsLoading(false)
    }
    const permission = [
        {
            id: '/dashboard',
            description: 'Dashboard',
        },
        {
            id: '/ioi_request',
            description: 'Indication of Interest Approval',
        },

        {
            id: '/listing',
            description: 'All Auctions',
        },

        {
            id: '/buyers',
            description: 'All Users',
        },
        {
            id: '/users/active',
            description: 'Active Users',
        },
        {
            id: '/users/deactivate',
            description: 'Deactivated Users',
        },
        {
            id: '/users/unverified',
            description: 'Unverified Users',
        },
        {
            id: '/users/rejected',
            description: 'Restricted Users',
        },
        {
            id: '/org',
            description: 'All Active Users',
        },
        {
            id: '/invoice',
            description: 'All Invoices',
        },

        {
            id: '/transaction/payment',
            description: 'Transactions Payment',
        },

        {
            id: '/store/configuration',
            description: 'Store Configuration',
        },

        {
            id: '/report',
            description: 'Report Management',
        },
        {
            id: '/subscribers',
            description: 'Subscribers',
        },
        {
            id: '/communications/email',
            description: 'Email Template',
        },
        {
            id: '/communications/sms',
            description: 'SMS Template',
        },

        {
            id: '/logs/emailLogs',
            description: 'Email Logs',
        },
        {
            id: '/logs/smsLogs',
            description: 'SMS Logs',
        },
        {
            id: '/settings/static',
            description: 'Static Pages',
        },
        {
            id: '/settings/palletPricing',
            description: 'Pallet Pricing',
        },
        {
            id: '/settings/location',
            description: 'Location',
        },
        {
            id: '/settings/general',
            description: 'General Settings',
        },
        {
            id: '/settings/maintanence',
            description: 'Maintanence',
        },
        {
            id: '/settings/bid_increments',
            description: 'Bid Increments',
        },
        {
            id: '/ui_settings',
            description: 'UI Settings',
        },
        {
            id: '/languageManager',
            description: 'LanguageManager',
        },
        {
            id: '/change_password',
            description: 'Change Password',
        },
    ]
    const [permissionSelect, setPermissionSelect] = useState(permission)

    const validationArray = Yup.object({
        emp_email: Yup.string()
            .email('Invalid email format')
            .required('Required!'),
        confirm_email: Yup.string(),
        emp_firstname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_lastname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_address1: Yup.string().required('Required!'),
        emp_phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        emp_type: Yup.string().required('Required!'),
        emp_city: Yup.string().required('Required!'),
        emp_state: Yup.string().required('Required!'),
        emp_country: Yup.string().required('Required!'),
        emp_zip: Yup.string()
            .trim()
            .matches(/^[a-zA-Z0-9\s]*$/, 'Must be alphanumeric')
            .min(4, 'Minimum 4 characters')
            .max(8, 'Maximum 8 characters')
            .required('Required'),
        emp_permissions: Yup.array().required('Required!'),
        password: Yup.string(),
        confirm_password: Yup.string(),
    })

    const validationArrayPassword = Yup.object({
        password: Yup.string()
            .min(8, 'Minimum 8 characters')
            .required('Required!'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required!'),
    })
    const [formikValues, setFormikValues] = useState(initialValues)

    const personalDetailsNew = [
        {
            label: 'First name *',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-sm-6 col-12',
            name: 'emp_firstname',
            autoFocus: false,
        },
        {
            label: 'Last Name *',
            placeholder: 'Enter last name',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_lastname',
        },
        {
            label: 'Phone Number *',
            placeholder: 'Enter phone number',
            type: 'phone',
            class: 'col-sm-6 col-12',
            name: 'emp_phone',
        },
        {
            label: 'Employee Type *',
            placeholder: 'Enter employee type',
            class: 'col-sm-6 col-12',
            type: 'select',
            options:
                user.emp_type === 'super_admin'
                    ? [
                          { value: 'super_admin', show: 'Super Admin' },
                          { value: 'admin', show: 'Admin' },
                          { value: 'employee', show: 'Employee' },
                      ]
                    : [{ value: 'employee', show: 'Employee' }],
            name: 'emp_type',
        },
    ]

    personalDetailsNew.push({
        label: 'Email Address',
        placeholder: 'Enter email address',
        type: 'text',
        class: 'col-12',
        name: 'emp_email',
        disabled: true,
    })

    const passwordChange = [
        {
            label: 'New Password',
            placeholder: 'Enter a new password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Confirm Password',
            placeholder: 'Re-enter your new password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const locationDetails = [
        {
            label: 'Street Address *',
            placeholder: 'Enter street address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_address1',
        },
        {
            label: 'Country *',
            placeholder: 'Select country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_country',
            disabled: true,
        },
        {
            label: 'State *',
            placeholder: 'Select state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formikValues.emp_country
                            ? formikValues.emp_country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_state',
        },
        {
            label: 'City *',
            placeholder: 'Enter city',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_city',
        },
        {
            label: 'ZIP *',
            placeholder: 'Enter ZIP',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_zip',
        },
    ]

    useEffect(() => {
        if (formikValues.emp_type === 'super_admin') {
            permission.push(
                {
                    id: '/employees/all',
                    description: 'All Employees',
                },
                {
                    id: '/settings/static',
                    description: 'Static Pages',
                },
                {
                    id: '/settings/general',
                    description: 'General Settings',
                },
                // {
                //     id: '/settings/banner',
                //     description: 'Banner Image',
                // },
                // {
                //     id: '/settings/category',
                //     description: 'Category',
                // },
                // {
                //     id: '/settings/condition',
                //     description: 'Condition',
                // },
                {
                    id: '/settings/location',
                    description: 'Location',
                },
                {
                    id: '/settings/bid_increments',
                    description: 'Bid Increments',
                },
                {
                    id: '/change_password',
                    description: 'Change Password',
                }
                // {
                //     id: '/settings/tax_code',
                //     description: 'Tax code',
                // }
            )
            setPermissionSelect(permission)
        } else if (formikValues.emp_type === 'admin') {
            permission.push({
                id: '/employees/all',
                description: 'All Employees',
            })
            setPermissionSelect(permission)
        } else {
            setPermissionSelect(permission)
        }
    }, [formikValues.emp_type])

    useEffect(() => {
        setFormikValues(initialValues)
    }, [initialValues])

    const super_admin_permission = [
        '/dashboard',
        '/ioi_request',
        '/listing',
        '/buyers',
        '/invoice',
        '/return/completed',
        '/store/themes',
        '/store/configuration',
        '/shipping/awaiting',
        '/report',
        '/subscribers',
        '/communications/email',
        '/communications/sms',
        '/logs/emailLogs',
        '/logs/smsLogs',
        '/comments',
        '/settings/banner',
        '/employees/all',
        '/settings/static',
        '/settings/general',
        '/settings/location',
        '/settings/bid_increments',
        '/change_password',
        '/settings/tax_code',
    ]
    const admin_permission = [
        '/dashboard',
        '/listing',
        '/ioi_request',
        '/buyers',
        '/invoice',
        '/return/completed',
        '/store/themes',
        '/store/configuration',
        '/shipping/awaiting',
        '/report',
        '/subscribers',
        '/communications/email',
        '/communications/sms',
        '/logs/emailLogs',
        '/logs/smsLogs',
        '/comments',
        '/settings/banner',
    ]

    const permissionDetails = [
        {
            type: 'check',
            class: 'empPermissions d-flex align-items-center flex-wrap',
            name: 'emp_permissions',
            options: permissionSelect,
        },
    ]

    const formikValueUpdate = (value) => {
        setFormikValues(value)
    }

    const closeFunction = () => {
        handleRedirectInternal(history, `employees/all`)
    }

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <EmployeeForm
                employeeId={employeeId}
                initialValues={initialValues}
                passwordInitialValues={passwordInitialValues}
                validationArray={validationArray}
                validationArrayPassword={validationArrayPassword}
                permissionDetails={permissionDetails}
                locationDetails={locationDetails}
                passwordChange={passwordChange}
                personalDetailsNew={personalDetailsNew}
                toggleFullScreenPopup={props.function}
                formikValueUpdate={formikValueUpdate}
                employeeFunctionEdit={employeeFunctionEdit}
                closeFunction={closeFunction}
                resetFrom={resetFrom}
                super_admin_permission={super_admin_permission}
                admin_permission={admin_permission}
                status={'edit'}
                dynamicPermission={
                    global?.dynamicPermission
                        ? global?.dynamicPermission
                        : false
                }
                autoenable={global?.autoenable ? global?.autoenable : false}
                noFullScreen={
                    global?.noFullScreen ? global?.noFullScreen : false
                }
                deactivated={global?.deactivated ? global?.deactivated : false}
            />
        </Layout>
    )
}

export default EmployeeEdit
